<template>
  <span>
    <div class="banner p1-3 mt-3">Company Overview</div>
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12 col-lg-10">
          <h2 style="font-weight: bold">About Us</h2>
          <p>
            PGP Title oversees the interests of all people involved in a real
            estate transaction (the Buyer, Seller, Lender and Real Estate
            Agent). After closing, funding and recording of your transaction,
            PGP Title will issue the Title Insurance Policy to cover the title
            to your property.
          </p>
          <p>
            We are comprised of a group of full-service title and settlement
            agents who are wholly-owned subsidiaries of the consumer inspired
            homebuilder, PulteGroup, Inc., whose family of brands includes Pulte
            Homes, Centex, DelWebb, and DiVosta. PGP Title has a long history of
            collaborating with our builder and mortgage partners to achieve
            efficient and on-time closings. Our employees are highly trained,
            experienced professionals who are leaders in customer satisfaction
            among settlement providers across the country.
          </p>
          <ul>
            <li>
              Headquartered in Dallas, Texas, we have 19 office locations which
              provide settlement services in 18 states throughout the country.
            </li>
            <li>
              We have proudly served Pulte, Centex and DelWebb buyers for more
              than 20 years.
            </li>
            <li>
              We are members of the American Land Title Association (“ALTA”) and
              Real Estate Services Providers Council, Inc. (“RESPRO”) as well as
              local land title associations.
            </li>
            <li>We are a RESPRO 2013 Regulatory Achievement Award Winner.</li>
            <li>
              We offer additional affiliated services through our national
              underwriter, Premier Land Title Insurance Company.
            </li>
          </ul>
          <p>
            We offer the financial security of a national firm, along with the
            diligence and know-how of a local, neighborhood company.
          </p>
          <p>
            Through highly integrated processes and seamless communications with
            our homebuilding and mortgage partners, we are committed to
            exceeding your expectations and providing peace of mind with your
            real estate transaction. With PGP Title and the PulteGroup family of
            companies, you will experience a cohesive team that will concentrate
            on the details, so that you can truly enjoy the excitement that
            comes with building a home.
          </p>
          <p>
            At PGP Title, our overriding goal is to support the embodiment of
            the American dream. Buying a new home is a true life event and
            accomplishment to be enjoyed by you, your family and your friends.
            We are excited to be a part of building consumer inspired homes to
            make lives better. You are a valued partner – now and in the future;
            a Customer for Life.
          </p>
          <p></p>
          <br />
        </div>
      </div>
    </div>
    <div id="diversity-section" class="align-items-center pt-5 pb-5 grey-bg">
      <div
        id="diversity-image"
        class="text-center pr-3 pl-3 col-md-8 offset-md-2 col-10 offset-1 offset-sm-1 col-sm-10 offset-xl-2 col-xl-3 col-lg-4 offset-lg-0"
      >
        <img
          src="../../assets/images/diversity-inclusion-image.jpg"
          alt="We are a Diverse and Inclusive environment."
          class="img-fluid"
        />
      </div>
      <div
        id="diversity-text-container"
        class="col-md-8 offset-md-2 col-sm-10 offset-sm-1 offset-lg-0 col-lg-8 pr-3 pl-3 col-xl-5 offset-0 col-12"
      >
        <div class="highlight-msgcontainer ps-4 pe-4">
          <div txtcolor="grey" headlinecolor="headline">
            <h5 class="subheadline">Embracing Diversity</h5>
            <p class="message">
              At PGP Title, we pride ourselves in being an Equal Opportunity
              Employer who values diversity and inclusion. We are committed to
              fostering a culture that embraces similarities and differences
              alike while striving toward the common goal of providing our
              customers with the best closing experience possible. By embracing
              the perspectives, lifestyles, experiences, and behaviors that
              makes each of us unique, we can better work together and serve our
              communities.
            </p>
          </div>
        </div>
      </div>
    </div>
  </span>
</template>

<style scoped>
div {
  font-family: Source Sans Pro, Arial, Helvetica, sans-serif;
  text-align: left;
}

h2 {
  font-size: 30px;
  margin: 0 0 8px;
}

p {
  font-size: 16px;
  color: #202a2f;
  margin: 0 0 16px;
}
</style>

<script setup></script>
